<div class="card">
  <ng-content></ng-content>
</div>
